'use client';
import e from 'prop-types';
import { createComponent } from '../core/create-component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t.push.apply(t, n);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
let t = {
    skin: e.oneOf([
        'standard',
        'checkmark',
        'shaded',
        'minimal'
    ]),
    start: e.number
};
const OrderedList = createComponent({
    displayName: 'OrderedList',
    root: 'ol',
    propTypes: t,
    propConfig: {
        classNames (e) {
            let r = new Set([
                'swan-list'
            ]), { skin: t = 'standard' } = e;
            return 'standard' != t && r.add(`swan-list-skin-${t}`), r;
        },
        processProps: (e)=>_object_spread_props(_object_spread({}, e), {
                style: _object_spread_props(_object_spread({}, e.style || {}), {
                    '--swan-internal-ordered-list-counter': e.start
                })
            })
    }
});

export { OrderedList };
